import styled from "styled-components";

const bp = { md: "768px", lg: "1100px" };

const c = {
  card: "#262626",
  cardSoft: "#2f2f2f",
  ink: "rgba(255,255,255,0.94)",
  muted: "rgba(255,255,255,0.66)",
  hairline: "rgba(184,145,57,0.34)",
  goldHair: "rgba(201,162,39,0.48)",
  goldDark: "#b08a2e",
  goldDeep: "#ffd846",
  pink: "#f59ac0",
  pinkStrong: "#ef6ea8",
  btnText: "#1a1a1a",
};

export const Wrap = styled.div`
  max-width: 1240px;
  margin: 0 auto;
`;

export const Section = styled.section`
  margin-bottom: 24px;
  scroll-margin-top: 150px;

  & + & {
    margin-top: 20px;
    padding-top: 12px;
  }

  @media (max-width: ${bp.md}) {
    margin-bottom: 22px;

    & + & {
      margin-top: 18px;
      padding-top: 12px;
    }
  }
`;

export const PanelTitle = styled.h2`
  margin: 0 0 14px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  font-size: 28px;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.86);

  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: "◆";
    font-size: 12px;
    line-height: 1;
    color: rgba(201, 162, 39, 0.95);
    transform: translateY(-1px);
  }

  @media (max-width: ${bp.md}) {
    font-size: 24px;
    margin-bottom: 12px;
    line-height: 1.4;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media (max-width: ${bp.lg}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 15px;
  }

  @media (max-width: ${bp.md}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
`;

export const ProductCard = styled.div`
  position: relative;
  background: ${c.card};
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid ${c.hairline};
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(201, 162, 39, 0.12);

  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;

  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    border-color 180ms ease;

  @media (hover: hover) {
    &:hover {
      transform: translateY(-3px);
      box-shadow:
        0 12px 26px rgba(0, 0, 0, 0.2),
        0 0 0 1px rgba(201, 162, 39, 0.24);
      border-color: ${c.goldHair};
    }
  }

  .imgWrap {
    padding: 9px;
    background: ${c.cardSoft};
    border-bottom: 1px solid rgba(201, 162, 39, 0.12);
  }

  @media (max-width: ${bp.md}) {
    border-radius: 15px;

    .imgWrap {
      padding: 8px;
    }
  }
`;

export const ProductImg = styled.img`
  width: 100%;
  display: block;
  aspect-ratio: 1.18 / 1;
  object-fit: cover;
  border-radius: 11px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);

  @media (max-width: ${bp.md}) {
    aspect-ratio: 1 / 1;
    border-radius: 10px;
  }
`;

export const ProductBody = styled.div`
  padding: 10px 10px 4px;
  flex: 1;

  @media (max-width: ${bp.md}) {
    padding: 9px 9px 4px;
  }
`;

export const ProductName = styled.div`
  color: ${c.ink};
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.02em;
  font-size: 15px;
  line-height: 1.2;
  text-align: center;

  @media (max-width: ${bp.md}) {
    font-size: 14px;
  }
`;

export const ProductDesc = styled.div`
  margin-top: 5px;
  color: ${c.muted};
  font-size: 11.5px;
  line-height: 1.45;
  text-align: center;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  min-height: 32px;

  @media (max-width: ${bp.md}) {
    font-size: 11px;
    min-height: 30px;
  }
`;

export const ProductFooter = styled.div`
  padding: 6px 10px 10px;
  display: grid;
  gap: 8px;

  @media (max-width: ${bp.md}) {
    padding: 6px 9px 9px;
    gap: 8px;
  }
`;

export const ProductPriceWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

export const ProductOldPrice = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.42);
  text-decoration: line-through;
  line-height: 1;
  font-weight: 600;

  @media (max-width: ${bp.md}) {
    font-size: 11px;
  }
`;

export const ProductPrice = styled.div`
  text-align: center;
  font-weight: 800;
  letter-spacing: 0.01em;
  font-size: 18px;
  line-height: 1.05;
  color: ${c.pink};

  text-shadow: 0 0 12px rgba(252, 154, 196, 0.1);

  &::after {
    content: "";
    display: block;
    width: 42px;
    height: 1px;
    margin: 7px auto 0;
    background: rgba(201, 162, 39, 0.34);
  }

  @media (max-width: ${bp.md}) {
    font-size: 17px;

    &::after {
      width: 38px;
      margin-top: 6px;
    }
  }
`;

export const DiscountBadge = styled.div`
  position: absolute;
  top: 9px;
  right: 9px;
  z-index: 5;

  min-width: 46px;
  height: 46px;
  padding: 0 8px;
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: ${c.pinkStrong};
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.01em;

  box-shadow:
    0 6px 14px rgba(0, 0, 0, 0.18),
    0 0 0 3px rgba(255, 255, 255, 0.92);

  @media (max-width: ${bp.md}) {
    min-width: 42px;
    height: 42px;
    font-size: 11px;
    top: 8px;
    right: 8px;
  }
`;

export const AddBtn = styled.button`
  width: 100%;
  height: 38px;
  border-radius: 11px;
  border: 1px solid rgba(176, 138, 46, 0.32);

  background: ${c.pink};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  color: #111;
  font-weight: 1000;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;

  svg {
    font-size: 13px;
    color: ${c.goldDeep};
  }

  transition:
    transform 160ms ease,
    opacity 160ms ease,
    filter 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      opacity: 0.96;
      transform: translateY(-1px);
      filter: saturate(1.03);
      border-color: rgba(176, 138, 46, 0.48);
      box-shadow: 0 6px 14px rgba(176, 138, 46, 0.12);
    }
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  @media (max-width: ${bp.md}) {
    height: 36px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 1200;

    svg {
      font-size: 12px;
    }
  }
`;

export const Empty = styled.div`
  padding: 14px 10px;
  color: rgba(0, 0, 0, 0.55);
`;

export const ProductGramaj = styled.div`
  margin-top: 6px;
  color: #ceaf41;
  font-size: 11.5px;
  line-height: 1.4;
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.01em;

  @media (max-width: ${bp.md}) {
    font-size: 11px;
  }
`;
